export const MENU = {
  home: "/web",
  pdpa: "/web/footer/pdpa",
  tnc: "/web/footer/terms_and_condition",
} as const;
